import React from 'react';
import { Redirect } from 'react-router';

import Auth from '../services/auth';

const auth = new Auth();
const isAuthenticated = auth.isAuthenticated();

const AuthGuard = ChildComponent => props => {
  return (
    isAuthenticated ? <ChildComponent {...props}/> : <Redirect to='/user/login'/> 
  );
}

export default AuthGuard;